module.exports = __webpack_public_path__ + "static/pehliKiran-22347f6916626729606b8cc8511d2dc1.png";